import logo from '../assets/logo_new.png'
import visa from '../assets/Visa.png'
import mastercard from '../assets/Mastercard.png'
import paypal from '../assets/Paypal.png'
import bancontact from '../assets/Bancontact.png'
import { useLanguage } from '../i18n/LanguageContext'
import { footerContent } from '../i18n/content/footer'

export default function Footer() {
    const { lang, withPath } = useLanguage();
    const c = footerContent[lang];

    return (
        <footer className="bg-surface-alt text-ink border-t border-line">
            {/* Upper Section */}
            <div className="main-content py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Left Column - Logo and Description */}
                    <div className="lg:col-span-1">
                        <a href={withPath('/')} className="flex items-center gap-3 mb-4">
                            <img src={logo} alt="Logo" loading="lazy" className="w-12 h-12" />
                            <span className="text-xl font-bold text-primary">LIGUEE1</span>
                        </a>
                        <p className="text-ink-muted leading-relaxed">
                            {c.blurb}
                        </p>
                    </div>

                    {/* Middle Column - Quick Links */}
                    <div>
                        <h3 className="text-lg font-bold mb-4 text-ink">{c.quickLinks}</h3>
                        <div className="w-12 h-1 bg-primary rounded-full mb-4"></div>
                        <ul className="space-y-2">
                            <li>
                                <a href={withPath('/refundpolicy')} className="text-ink-muted hover:text-primary transition-colors duration-300">
                                {c.refundLink}
                                </a>
                            </li>
                            <li>
                                <a href={withPath('/privacypolicy')} className="text-ink-muted hover:text-primary transition-colors duration-300">
                                {c.privacyLink}
                                </a>
                            </li>
                            <li>
                                <a href={withPath('/termsandconditions')} className="text-ink-muted hover:text-primary transition-colors duration-300">
                                {c.termsLink}
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Column */}
                    <div>
                        <h3 className="text-lg font-bold mb-4 text-ink">{c.contact}</h3>
                        <div className="w-12 h-1 bg-primary rounded-full mb-4"></div>
                        <div className="space-y-3">
                            <div className="flex items-center gap-3">
                                <svg className="text-primary w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                                </svg>
                                <span className="text-ink-muted">contact@liguee1.com</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <svg className="text-primary w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                                </svg>
                                <a href="https://wa.me/32460201577" target="_blank" rel="noopener noreferrer" className="text-ink-muted hover:text-primary transition-colors duration-300">+32 460 20 15 77</a>
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Payment Methods */}
                    <div>
                        <h3 className="text-lg font-bold mb-4 text-ink">{c.weAccept}</h3>
                        <div className="w-12 h-1 bg-primary rounded-full mb-4"></div>
                        <div className={`grid gap-2 ${lang === 'es' ? 'grid-cols-3' : 'grid-cols-4'}`}>
                            <div className="bg-white border border-line rounded-lg p-2 flex items-center justify-center">
                                <img src={paypal} alt="PayPal" loading="lazy" className="h-9 w-auto" />
                            </div>
                            <div className="bg-white border border-line rounded-lg p-2 flex items-center justify-center">
                                <img src={visa} alt="VISA" loading="lazy" className="h-4 w-auto" />
                            </div>
                            <div className="bg-white border border-line rounded-lg p-2 flex items-center justify-center">
                                <img src={mastercard} alt="MasterCard" loading="lazy" className="h-6 w-auto" />
                            </div>
                            {lang !== 'es' && (
                                <div className="bg-white border border-line rounded-lg p-2 flex items-center justify-center">
                                    <img src={bancontact} alt="Bancontact" loading="lazy" className="h-6 w-auto" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Lower Section - Bottom Bar */}
            <div className="border-t border-line">
                <div className="main-content py-4">
                    <div className="text-sm text-center text-ink-muted">
                        {c.copyright}
                    </div>
                </div>
            </div>
        </footer>
    )
}
